var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"governance-status-badge",class:`governance-status-badge--${_vm.tone}`},[_vm._v(_vm._s(_vm.status))])
}
var staticRenderFns = []

export { render, staticRenderFns }